var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8594 12.45L27.1219 18H20.25C18.1781 18 16.5 16.3219 16.5 14.25C16.5 12.1781 18.1781 10.5 20.25 10.5H20.4562C21.8531 10.5 23.1562 11.2406 23.8594 12.45ZM12 14.25C12 15.6 12.3281 16.875 12.9 18H9C7.34062 18 6 19.3406 6 21V27C6 28.6594 7.34062 30 9 30H51C52.6594 30 54 28.6594 54 27V21C54 19.3406 52.6594 18 51 18H47.1C47.6719 16.875 48 15.6 48 14.25C48 9.69375 44.3063 6 39.75 6H39.5437C36.5531 6 33.7781 7.58438 32.2594 10.1625L30 14.0156L27.7406 10.1719C26.2219 7.58437 23.4469 6 20.4562 6H20.25C15.6938 6 12 9.69375 12 14.25ZM43.5 14.25C43.5 16.3219 41.8219 18 39.75 18H32.8781L36.1406 12.45C36.8531 11.2406 38.1469 10.5 39.5437 10.5H39.75C41.8219 10.5 43.5 12.1781 43.5 14.25ZM9 33V49.5C9 51.9844 11.0156 54 13.5 54H27V33H9ZM33 54H46.5C48.9844 54 51 51.9844 51 49.5V33H33V54Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEClaim);
export default __webpack_public_path__ + "static/media/e-claim.8741ea4e6f3c011f04d8249fa7a59e3c.svg";
export { ForwardRef as ReactComponent };